<div class="flex flex-col" [formGroup]="colorForm">
    <div class="flex flex-row justify-end">
      <p-colorPicker class="mt-1" [formControlName]="'colorFormControl'"></p-colorPicker>
      <nx-default-button
        [disabled]="colorForm.disabled"
        (click)="reset()"
        tooltip="Auf Standardwert zurücksetzen"
        class="flex justify-end ml-2"
        [icon]="'icon-return'">
      </nx-default-button>
  </div>
</div>